import React, { lazy } from 'react';
import { MediaPlaceholder } from './MediaPlaceholder';
interface VideoTestimonialProps {
  youtubeId?: string;
  index: number;
}
export function VideoTestimonial({
  youtubeId,
  index
}: VideoTestimonialProps) {
  // Sin video cargado todavía: mostramos el placeholder editable
  if (!youtubeId) {
    return <div className="relative aspect-video bg-brand-dark rounded-lg overflow-hidden border border-gray-800 group" data-id="element-117">
        <MediaPlaceholder type="video" text={`[Video Testimonio ${index + 1}]`} className="w-full h-full border-none rounded-none" data-id="element-118" />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-119">
          <div className="w-12 h-8 bg-red-600 rounded-lg flex items-center justify-center opacity-80" data-id="element-120">
            <div className="w-0 h-0 border-t-4 border-t-transparent border-l-[6px] border-l-white border-b-4 border-b-transparent ml-1" data-id="element-121" />
          </div>
        </div>
      </div>;
  }
  // Embed directo de YouTube: se reproduce en un solo paso, sin miniatura intermedia
  return <div className="relative aspect-video bg-black rounded-lg overflow-hidden border border-gray-800" data-id="element-122">
      <iframe className="absolute inset-0 w-full h-full" src={`https://www.youtube.com/embed/${youtubeId}?rel=0`} title={`Video testimonio ${index + 1}`} allow="accelerated-sensors; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy" data-id="element-123" />
    </div>;
}